import React, { ReactElement, useEffect, useMemo } from 'react';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import { DataCollectionValues, useDataCollection } from '../../../../hooks';
import { Form } from 'formik';
import StepHeader from '../../../components/Layout/StepHeader';
import InputCard from '../../../components/Form/InputCard';
import { WizardStep } from '../../../../types';

interface FormError {
    garageArea?: string;
    basementArea?: string;
    atticArea?: string;
}

const stepValidation = (values: DataCollectionValues) => {
    const errors: FormError = {};

    if (values.garageArea && Number(values.garageArea) < 0) {
        errors.garageArea = 'Povinné pole';
    }
    if (values.basementArea && Number(values.basementArea) < 0) {
        errors.basementArea = 'Povinné pole';
    }
    if (values.atticArea && Number(values.atticArea) < 0) {
        errors.atticArea = 'Povinné pole';
    }

    return errors;
};

const StepGarageBasementAtticArea = ({
    completeStep,
    setNextStepId,
}: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    const errors = useMemo(() => stepValidation(values), [values]);
    useEffect(() => {
        const nextStepId = Number(values?.atticArea) > 0 ? WizardStep.AtticHeated : WizardStep.RoomDispositions;
        setNextStepId && setNextStepId(nextStepId);
        completeStep && completeStep(!Object.keys(errors).length);
    }, [errors]);

    return (
        <Form>
            <div className="otz-main otz-main--basement-attic-area">
                <StepHeader title="Je součástí Vašeho domu..." subtitle="Vyberte všechny platné možnosti" />
                <div className="otz-content-small">
                    <div className="row otz-row--md flex-jc-c">
                        <div className="col col--md-6 col--lg-4 p-l-10 p-r-10 m-b-20">
                            <InputCard
                                title="Garáž"
                                subtitle="Je přímou součástí Vašeho domu garáž"
                                name="garageArea"
                                id="garageArea"
                                label="Odhadovaná plocha"
                                type="number"
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.garageArea}
                                error={errors.garageArea}
                                // eslint-disable-next-line prettier/prettier
                                unit={<>m<sup>2</sup></>}
                            />
                        </div>
                        <div className="col col--md-6 col--lg-4 p-l-10 p-r-10 m-b-20">
                            <InputCard
                                title="Sklep"
                                subtitle="Je Váš dům částečně či zcela podsklepený?"
                                name="basementArea"
                                id="basementArea"
                                label="Odhadovaná plocha"
                                type="number"
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.basementArea}
                                error={errors.basementArea}
                                // eslint-disable-next-line prettier/prettier
                                unit={<>m<sup>2</sup></>}
                            />
                        </div>
                        <div className="col col--md-6 col--lg-4 p-l-10 p-r-10 m-b-20">
                            <InputCard
                                title="Půda"
                                subtitle="Jako půdu klasifikujeme neobydlený podkrovní prostor"
                                name="atticArea"
                                id="atticArea"
                                label="Odhadovaná plocha"
                                type="number"
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.atticArea}
                                error={errors.atticArea}
                                // eslint-disable-next-line prettier/prettier
                                unit={<>m<sup>2</sup></>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepGarageBasementAtticArea;
